import {
    CreditCardOutlined
} from '@ant-design/icons';
import {
    Alert,
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Cascader, InputNumber } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import { serverTimestamp } from 'firebase/firestore';
import React, { useEffect, useMemo, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apis from '../../apis';
import register_poster from "../../assets/images/register_poster.png";
import FileInput from '../../components/molecules/FileInput';
import RadioForm from '../../components/molecules/Form/RadioForm';
import LoadingOverlay from '../../components/molecules/LoadingOverlay';
import { countryCodes } from '../../constant/CountryCodePhone';
import { PaymentStatus } from '../../constant/PaymentStatus';
import { ageCategories, brassAgeCategoriesSolo, BrassInstrumentListSolo, competitionList, electoneAgeCategoriesSolo, ElectoneInstrumentListSolo, ensembleAgeCategories, guitarAgeCategoriesSolo, GuitarInstrumentListSolo, guzhengAgeCategoriesEnsemble, guzhengAgeCategoriesSolo, GuzhengInstrumentListEnsemble, GuzhengInstrumentListSolo, harpAgeCategoriesSolo, HarpInstrumentListSolo, InstrumentListEnsembleNew, percussionAgeCategoriesSolo, PercussionInstrumentListSolo, PerformanceCategory, PianoInstrumentListSolo, stringAgeCategoriesSolo, StringsInstrumentListSolo, vocalAgeCategoriesSolo, VocalChoirInstrumentEnsembleClassical, VocalChoirInstrumentEnsembleFreeGenre, VocalGenreCategory, VocalInstrumentListSolo, woodwinAgeCategoriesSolo, WoodwindInstrumentListSolo } from '../../constant/RegisterPageConst';
import { useAuth } from '../../context/DataContext';
import { getAge, isAgeInCategory } from '../../utils/Utils';
import { calculatePrice } from '../../utils/priceProvider';
import CustomNumberInput from './CustonNumberInput';
import SubmissionConfirmationModal from './SubmissionConfirmationModal';

const Register = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const IdCode = '+62';
    const examInputRef = useRef();
    const paymentProofInputRef = useRef();
    const profilePhotoInputRef = useRef();
    const birthCertInputRef = useRef();
    const repertoireInputRef = useRef();
    const videoPerformanceInputRef = useRef();
    const recaptchaRef = useRef();

    const userType = {
        Teacher: t("register.imTeacher"),
        Personal: t("register.imParent"),
    }

    const gender = {
        Male: t("register.gender.Male"),
        Female: t("register.gender.Female"),
        Other: t("register.gender.Other")
    }

    const { isSmallMobileAndSmaller, currentEventId, isRegistrationEnabled } = useAuth();

    const [isLoading, setIsLoading] = useState(false);
    const [isSaveSuccess, setIsSaveSuccess] = useState(false);
    const [totalPerformer, setTotalPerformer] = useState(1);
    const [progressLoading, setProgressLoading] = useState(10);
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(true);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [performerAge, setPerformerAge] = useState(false);
    const [paymentLink, setPaymentLink] = useState("");

    const { unregister, setValue, watch, register, control, formState: { errors }, handleSubmit, reset, clearErrors } = useForm({
        defaultValues: {
            ageCategory: null,
            userType: "Teacher",
            competitionCategory: "",
            instrumentCategory: "",
            vocalGenreCategory: VocalGenreCategory.Classical,
            traditionalInstrument: "",
            name: "",
            youtubeLink: "",
            remark: "",
            performers: [{
                fullName: "",
                email: "",
                phoneNumber: "",
                countryCode: ["+62"],
                city: "",
                country: "",
                province: "",
                zipCode: "",
                addressLine: "",
                dob: null
            }],
            totalPerformer: 1,
            PerformanceCategory: PerformanceCategory.Solo,
            sameAddress: false
        },
        mode: "onBlur", // or "onBlur"
        shouldUnregister: false,
    })

    const selectedCompetition = watch("competitionCategory");
    const userTypeValue = watch("userType");
    const instrumentCategoryValue = watch("instrumentCategory");
    const vocalGenreCategoryValue = watch("vocalGenreCategory");
    const PerformanceCategoryValue = watch("PerformanceCategory");
    const sameAddressValue = watch("sameAddress");
    const youtubeLinkValue = watch("youtubeLink");
    const watchedFieldsPerformer = watch("performers");
    const performersValue = useWatch({ control, name: "performers" });

    const { fields, append, remove } = useFieldArray({
        control,
        name: "performers"
    });

    const getVideoDuration = (file) => {
        return new Promise((resolve, reject) => {
            try {
                const video = document.createElement('video');
                video.preload = 'metadata';

                video.onloadedmetadata = function () {
                    window.URL.revokeObjectURL(video.src);
                    resolve(video.duration); // Duration in seconds
                }

                video.onerror = function () {
                    resolve(0); // Return 0 if fails
                }

                video.src = URL.createObjectURL(file);
            } catch (e) {
                resolve(0);
            }
        });
    };

    const getFirstErrorKey = (errorObj, path = '') => {
        for (const key in errorObj) {
            const newPath = path ? `${path}.${key}` : key;
            const val = errorObj[key];
            if (val?.message) {
                return newPath;
            } else if (typeof val === 'object') {
                const nested = getFirstErrorKey(val, newPath);
                if (nested) return nested;
            }
        }
        return null;
    };

    const onError = (errors) => {
        const fullErrorKey = getFirstErrorKey(errors);
        if (!fullErrorKey) return;

        const errorElement = document.querySelector(`[name="${fullErrorKey}"]`);
        const errorElementID = document.getElementById(fullErrorKey);

        // Check if this is a file input by checking tagName + type
        const isHiddenFileInput =
            errorElement?.tagName === "INPUT" &&
            errorElement?.type === "file" &&
            getComputedStyle(errorElement).display === "none";

        let targetElement = null;

        if (isHiddenFileInput) {
            // Prefer scrolling to a visible wrapper for file inputs
            targetElement = document.getElementById(`file-input-wrapper-${fullErrorKey}`);
        }

        // Fallbacks if not a hidden file input
        targetElement = targetElement || errorElement || errorElementID;

        if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
            targetElement.focus?.({ preventScroll: true }); // preventScroll so it doesn't jump after scrolling
            setIsConfirmModalOpen(false)
        }
    };

    const handleCloseWarning = () => setIsWarningModalOpen(false);
    const handleOpenConfirmationModal = (event) => {
        if (!isSaveSuccess) {
            event.preventDefault()
            setIsConfirmModalOpen(true)
        }
    }



    const isInternationalRegistrant = useMemo(() => {
        if (!watchedFieldsPerformer) {
            return false;
        }
        return watchedFieldsPerformer.some(
            performer => performer?.countryCode?.[0] !== IdCode
        );
    }, [JSON.stringify(watchedFieldsPerformer), IdCode]);

    const uploadLargeVideo = async (file, directoryName) => {
        const chunkSize = 10 * 1024 * 1024; // 10MB chunks
        const chunks = Math.ceil(file.size / chunkSize);

        // Start multipart upload
        const initRes = await apis.aws.initiateMultipartUpload(directoryName, file.name, file.type);
        const uploadId = initRes.data.data.uploadId;

        const uploadPromises = [];
        const uploadedParts = [];

        for (let i = 0; i < chunks; i++) {
            const start = i * chunkSize;
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end);

            const partNumber = i + 1;

            // Upload chunks in parallel
            const uploadPromise = (async () => {
                const partRes = await apis.aws.getPartUploadUrl(directoryName, file.name, uploadId, partNumber);
                const partUrl = partRes.data.data.link;

                const response = await axios.put(partUrl, chunk, {
                    headers: { 'Content-Type': file.type }
                });

                return {
                    ETag: response.headers.etag,
                    PartNumber: partNumber
                };
            })();

            uploadPromises.push(uploadPromise);

            // Update progress
            uploadPromise.then(() => {
                const progress = 35 + Math.floor(((i + 1) / chunks) * 50);
                // setProgressLoading(progress);
            });
        }

        // Wait for all parts
        const parts = await Promise.all(uploadPromises);
        uploadedParts.push(...parts.sort((a, b) => a.PartNumber - b.PartNumber));

        // Complete multipart upload
        await apis.aws.completeMultipartUpload(directoryName, file.name, uploadId, uploadedParts);

        return `s3://registrants2025/${directoryName}/${file.name}`;
    };

    const onSubmit = async (data) => {
        const token = recaptchaRef.current.getValue();
        if (!token) {
            toast.error(t("register.recaptchaError"));
            return;
        }

        try {
            setIsConfirmModalOpen(false);
            setIsLoading(true);

            // 1. Prepare Performer Data
            const formattedDatePerformers = data?.performers.map((performer) => {
                const formattedDate = performer?.dob?.format("DD/MM/YYYY") ?? null;
                return { ...performer, dob: formattedDate, countryCode: performer.countryCode[0] }
            });

            if (formattedDatePerformers.length <= 0) {
                throw new Error('No valid performer data found to process.');
            }

            // 2. Upload Files (Keep your existing logic exactly as is)
            const now = new Date();
            const timestamp = now.toISOString().replace(/[-:.TZ]/g, "").slice(0, 14);
            // const profilePhoto = data.profilePhoto[0];
            // const baseName = profilePhoto.name.replace(/\s/g, "").replace(/\.[^/.]+$/, "");
            const directoryName = `${formattedDatePerformers[0].fullName}_${timestamp}`;

            // const res = await apis.aws.postSignedUrl(directoryName, "profilePhoto.pdf", 'application/pdf')
            // const signedUrl = res.data.link
            // await axios.put(signedUrl, profilePhoto, {
            //     headers: {
            //         'Content-Type': profilePhoto.type,
            //     },
            // });
            // const profilePhotoS3Link = `s3://registrants2025/${directoryName}/profilePhoto.pdf`;
            setProgressLoading(10)

            //save birth cert first
            const birthCert = data.birthCertificate[0]
            const resBirthCert = await apis.aws.postSignedUrl(directoryName, "birthCert.pdf", 'application/pdf')
            const signedUrlBirthCert = resBirthCert.data.link
            await axios.put(signedUrlBirthCert, birthCert, {
                headers: {
                    'Content-Type': birthCert.type, // Ensure this matches the file type
                },
            });
            const birthCertS3Link = `s3://registrants2025/${directoryName}/birthCert.pdf`;
            setProgressLoading(20)

            //save pdf report
            const pdfRepertoire = data.pdfRepertoire[0]
            const res2 = await apis.aws.postSignedUrl(directoryName, "pdfRepertoire.pdf", 'application/pdf')
            const signedUrl2 = res2.data.link
            await axios.put(signedUrl2, pdfRepertoire, {
                headers: {
                    'Content-Type': pdfRepertoire.type,
                },
            });
            const pdfRepertoireS3Link = `s3://registrants2025/${directoryName}/pdfRepertoire.pdf`;
            setProgressLoading(30)

            //save video Perforamnce
            const videoPerformance = data.videoPerformance[0];
            let calculatedDuration = 0;
            try {
                calculatedDuration = await getVideoDuration(videoPerformance);
            } catch (err) {
                console.warn("Failed to calculate video duration locally", err);
            }
            const videoPerformanceS3Link = await uploadLargeVideo(videoPerformance, directoryName)
            setProgressLoading(35)

            setProgressLoading(50)
            //save exam cert
            // const examCertificate = data.examCertificate[0]
            // const res4 = await apis.aws.postSignedUrl(directoryName, "examCertificate.pdf", examCertificate.type)
            // const signedUrl4 = res4.data.link
            // await axios.put(signedUrl4, examCertificate, {
            //     headers: {
            //         'Content-Type': examCertificate.type,
            //     },
            // });
            // const examCertificateS3Link = `s3://registrants2025/${directoryName}/examCertificate.pdf`;
            setProgressLoading(70)


            // 3. Calculate Price Logic
            const isInternational = watchedFieldsPerformer?.some(
                performer => performer?.countryCode?.[0] !== IdCode
            );

            // Calculate the price before saving
            const priceData = await calculatePrice(data, isInternational);

            // 4. Prepare Firebase Payload
            const payload = {
                vocalGenreCategory: data?.vocalGenreCategory ?? "",
                ageCategory: data.ageCategory,
                totalPerformer: data.totalPerformer,
                agreement: data.agreement,
                competitionCategory: data.competitionCategory,
                PerformanceCategory: data.PerformanceCategory,
                instrumentCategory: data.instrumentCategory,
                traditionalInstrument: data?.traditionalInstrument ?? "",
                userType: data.userType,
                performers: formattedDatePerformers,
                name: data.name,
                youtubeLink: data.youtubeLink || "",
                remark: data?.remark ?? "",
                videoDuration: calculatedDuration || 0, // Or your calculated duration

                // S3 Links (Ensure these variables exist from your upload section)
                // profilePhotoS3Link,
                pdfRepertoireS3Link,
                birthCertS3Link,
                videoPerformanceS3Link,
                // paymentProofS3Link,
                // examCertificateS3Link,

                createdAt: serverTimestamp(),
                ...(data.teacherName && { teacherName: data.teacherName }),

                // PAYMENT STATUS
                // If there is a price, set to PENDING. If free, set to PAID.
                paymentStatus: priceData.amount > 0 ? PaymentStatus.PENDING : PaymentStatus.PAID,
                amountToPay: priceData.amount,
                currency: priceData.currency,
                recaptchaToken: token,
                eventId: currentEventId
            };

            //change to BE
            const response = await apis.register.submitRegistration(payload);
            const firebaseId = response.data.id;

            // 6. PAYMENT INTEGRATION: Create Paper.id Invoice
            if (priceData.amount > 0) {
                setProgressLoading(90);

                const mainContactEmail = data.performers[0].email;
                const mainContactPhone = `${data.performers[0].countryCode}${data.performers[0].phoneNumber}`.replace('+', '');

                // Prepare data for YOUR Backend
                const invoiceRequest = {
                    externalId: firebaseId, // Link invoice to Firebase ID
                    user: {
                        name: data.performers[0].fullName,
                        email: mainContactEmail,
                        phone: mainContactPhone
                    },
                    items: [
                        {
                            name: `Registration: ${data.competitionCategory} (${data.PerformanceCategory})`,
                            description: `${data.instrumentCategory} - ${data.ageCategory}`,
                            price: priceData.baseAmount || priceData.amount,
                            discount: (priceData.baseAmount && priceData.baseAmount > priceData.amount) ? (priceData.baseAmount - priceData.amount) : 0,
                            currency: priceData.currency,
                            quantity: data.totalPerformer
                        }
                    ]
                };

                const paperResponse = await apis.payment.createRegistrationInvoice(invoiceRequest);

                if (paperResponse?.data && paperResponse?.data?.paymentUrl) {
                    setIsLoading(false);
                    setIsSaveSuccess(true);
                    toast.success(t("register.registerSuccessRedirect"));

                    // 7. Redirect User to Paper.id Payment Page
                    setTimeout(() => {
                        window.open(paperResponse.data.paymentUrl, '_blank');
                        setPaymentLink(paperResponse.data.paymentUrl)
                        navigate(`/waiting-payment/${firebaseId}`, {
                            state: { paymentLink: paperResponse.data.paymentUrl }
                        });
                    }, 1500);

                    return; // Stop here, user is leaving the site
                }
            }

            // 8. Fallback / No Payment Logic (Existing Email Logic)

            const allNames = formattedDatePerformers.map(p => p.fullName).join(' & ');
            const emailGroups = formattedDatePerformers.reduce((acc, performer) => {
                const email = performer.email;

                if (!acc[email]) {
                    acc[email] = {
                        email: email,
                        name: allNames,
                        competitionCategory: data.competitionCategory,
                        instrumentCategory: data.instrumentCategory,
                        price: priceData.formattedAmount
                    };
                }

                return acc;
            }, {});

            // Convert to array and format names

            setProgressLoading(90)


            setIsLoading(false);
            setIsSaveSuccess(true);
            toast.success(t("register.registerSuccess"));

        } catch (e) {
            setIsLoading(false);
            toast.error(t("register.registerFailed"));
            console.error(e);
        }
    };

    const handleClickOpenPaymentLink = () => {
        window.open(paymentLink, '_blank');
    }

    const handleClickReset = () => {
        reset()
        setIsSaveSuccess(false)
        clearErrors()
        setTotalPerformer(1)
        // Clear file input
        if (examInputRef.current) {
            examInputRef.current.value = null;
        }
        if (paymentProofInputRef.current) {
            paymentProofInputRef.current.value = null;
        }
        if (birthCertInputRef.current) {
            birthCertInputRef.current.value = null;
        }
        if (profilePhotoInputRef.current) {
            profilePhotoInputRef.current.value = null;
        }
        if (repertoireInputRef.current) {
            repertoireInputRef.current.value = null;
        }
        if (videoPerformanceInputRef.current) {
            videoPerformanceInputRef.current.value = null;
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setProgressLoading(0)
    }

    // Sync the fields with `totalPerformer`
    useEffect(() => {
        const timer = setTimeout(() => {
            const currentLength = watchedFieldsPerformer.length;
            if (totalPerformer > currentLength) {
                for (let i = currentLength; i < totalPerformer; i++) {
                    append({
                        fullName: "",
                        email: "",
                        phoneNumber: "",
                        countryCode: ["+62"],
                        city: "",
                        country: "",
                        province: "",
                        zipCode: "",
                        addressLine: "",
                        dob: null
                    });
                }
            } else if (totalPerformer < currentLength) {
                for (let i = currentLength; i > totalPerformer; i--) {
                    remove(i - 1);
                }
            }
        }, 0)
        return () => clearTimeout(timer);

    }, [totalPerformer]);

    const isEnsemble = useMemo(() => {
        return totalPerformer > 1
    }, [totalPerformer])

    const performerExpText = useMemo(() => {
        if (!isEnsemble) {
            return t("register.form.performingSolo")
        } else {
            return t("register.form.performingEnsemble")
        }
    }, [isEnsemble])

    const handleChangePerformer = (value) => {
        setTotalPerformer(value)
        setValue('totalPerformer', value)
    }

    // Reset vocal genre when competition changes
    useEffect(() => {
        if (selectedCompetition !== competitionList.VocalChoir) {
            setValue('vocalGenreCategory', VocalGenreCategory.Classical);
        }
    }, [selectedCompetition, setValue]);

    // Reset categories when vocal genre changes
    useEffect(() => {
        if (selectedCompetition === competitionList.VocalChoir) {
            setValue('PerformanceCategory', PerformanceCategory.Solo);
            setValue('instrumentCategory', "");
            setValue('ageCategory', null);
        }
    }, [vocalGenreCategoryValue, selectedCompetition, setValue]);

    const instrumentCategoryList = useMemo(() => {
        if (PerformanceCategoryValue === PerformanceCategory.Ensemble) {
            // Vocal Choir ensemble selection based on genre
            if (selectedCompetition === competitionList.VocalChoir) {
                return vocalGenreCategoryValue === VocalGenreCategory.FreeGenre
                    ? VocalChoirInstrumentEnsembleFreeGenre
                    : VocalChoirInstrumentEnsembleClassical;
            }
            // Guzheng uses its own ensemble list
            if (selectedCompetition === competitionList.Guzheng) {
                return GuzhengInstrumentListEnsemble
            }
            // All other competitions use the universal ensemble list
            return InstrumentListEnsembleNew
        } else {
            // Solo logic
            switch (selectedCompetition) {
                case competitionList.Piano:
                    return PianoInstrumentListSolo
                case competitionList.Woodwinds:
                    return WoodwindInstrumentListSolo
                case competitionList.Percussions:
                    return PercussionInstrumentListSolo
                case competitionList.Guitar:
                    return GuitarInstrumentListSolo
                case competitionList.Harp:
                    return HarpInstrumentListSolo
                case competitionList.Guzheng:
                    return GuzhengInstrumentListSolo
                case competitionList.Brass:
                    return BrassInstrumentListSolo
                case competitionList.Strings:
                    return StringsInstrumentListSolo
                case competitionList.VocalChoir:
                    return VocalInstrumentListSolo
                case competitionList.Electone:
                    return ElectoneInstrumentListSolo
                default:
                    return {}
            }
        }
    }, [selectedCompetition, PerformanceCategoryValue])

    const filteredAgeCategories = useMemo(() => {
        if (PerformanceCategoryValue === PerformanceCategory.Ensemble) {
            if (selectedCompetition === competitionList.Guzheng) {
                return guzhengAgeCategoriesEnsemble
            }
            // Universal ensemble age assignment based on instrument selection
            if (instrumentCategoryValue?.includes('Non_Professionals')) {
                return { older_than_four: "4+ years old (Combination Age)" }
            } else if (instrumentCategoryValue?.includes('Professionals')) {
                return { nineteen_plus: "19+ years old" }
            }
            return ensembleAgeCategories
        } else {
            // Solo age lists
            switch (selectedCompetition) {
                case competitionList.Piano:
                    return ageCategories
                case competitionList.Woodwinds:
                    return woodwinAgeCategoriesSolo
                case competitionList.Percussions:
                    return percussionAgeCategoriesSolo
                case competitionList.Guitar:
                    return guitarAgeCategoriesSolo
                case competitionList.Harp:
                    return harpAgeCategoriesSolo
                case competitionList.Brass:
                    return brassAgeCategoriesSolo
                case competitionList.Strings:
                    return stringAgeCategoriesSolo
                case competitionList.VocalChoir:
                    if (vocalGenreCategoryValue === VocalGenreCategory.FreeGenre) {
                        return { FreeChoiceVocal: vocalAgeCategoriesSolo.FreeChoiceVocal }
                    }
                    // For Classical, exclude Free Choice
                    const classicalAgeCategories = { ...vocalAgeCategoriesSolo };
                    delete classicalAgeCategories.FreeChoiceVocal;
                    return classicalAgeCategories;
                case competitionList.Guzheng:
                    return guzhengAgeCategoriesSolo
                case competitionList.Electone:
                    return electoneAgeCategoriesSolo
                default:
                    return {}
            }
        }
    }, [selectedCompetition, PerformanceCategoryValue, instrumentCategoryValue])

    const filteredAgeCategoriesByAge = useMemo(() => {
        // 'age' must be available in your component's scope.
        // If no age is calculated yet, return the full list.
        if (typeof performerAge !== 'number') {
            return filteredAgeCategories;
        }

        const entries = Object.entries(filteredAgeCategories);

        if (PerformanceCategoryValue === PerformanceCategory.Ensemble) {
            // Actively loop through all performers and make sure EVERYONE satisfies the age category
            const validEntries = entries.filter(([key, description]) => {
                // If any participant has a DOB that violates the description, return false.
                return !watchedFieldsPerformer.some((performer) => {
                    if (performer && performer.dob) {
                        const currentAge = getAge(performer.dob);
                        return !isAgeInCategory(currentAge, description);
                    }
                    return false; // If no DOB is placed yet, assume they are valid temporarily
                });
            });

            return Object.fromEntries(validEntries);
        }

        // Solo Logic
        // 2. Filter this array, keeping only the categories that match the age
        const validEntries = entries.filter(([key, description]) => {
            return isAgeInCategory(performerAge, description);
        });

        // 3. Convert the filtered array back into an object
        return Object.fromEntries(validEntries);

    }, [performerAge, filteredAgeCategories, PerformanceCategoryValue, watchedFieldsPerformer]);

    const minimalPerformer = useMemo(() => {
        if (PerformanceCategoryValue === PerformanceCategory.Solo) {
            return 1
        } else {
            return 2
        }
    }, [PerformanceCategoryValue])

    const maximalPerformer = useMemo(() => {
        if (PerformanceCategoryValue === PerformanceCategory.Solo) {
            return 1;
        } else {
            return 30; // Max 30 for all ensembles
        }
    }, [PerformanceCategoryValue]);

    useEffect(() => {
        if (PerformanceCategoryValue === PerformanceCategory.Solo) {
            setTotalPerformer(1)
            setValue('totalPerformer', 1)
        } else {
            setTotalPerformer(2)
            setValue('totalPerformer', 2)
        }
    }, [PerformanceCategoryValue, selectedCompetition])

    const copyAddressFields = (from, to) => {
        setValue(`performers.${to}.addressLine`, from.addressLine);
        setValue(`performers.${to}.city`, from.city);
        setValue(`performers.${to}.country`, from.country);
        setValue(`performers.${to}.province`, from.province);
        setValue(`performers.${to}.zipCode`, from.zipCode);
    };

    useEffect(() => {
        if (!sameAddressValue) return;
        const source = performersValue?.[0];
        if (!source) return;

        for (let i = 1; i < performersValue.length; i++) {
            copyAddressFields(source, i);
        }
    }, [sameAddressValue, performersValue, setValue]);

    useEffect(() => {
        const age = getAge(performersValue[0].dob);
        setPerformerAge(age)
    }, [performersValue])

    const sameAddressCheckbox = useMemo(() => {
        return (
            <FormControlLabel
                key="sameAddressCheckbox"
                sx={{
                    color: "#e5cc92",
                    "&.Mui-focused": { color: "#e5cc92 !important" },
                    "&:hover": { color: "#e5cc92 !important" },
                }}
                control={
                    <Controller
                        name="sameAddress"
                        control={control}
                        render={({ field }) => (
                            <Checkbox
                                {...field}
                                sx={{
                                    color: "#e5cc92",
                                    "&.Mui-checked": {
                                        color: "#e5cc92",
                                    },
                                    "&.Mui-focusVisible": {
                                        outline: "2px solid #e5cc92",
                                    },
                                }}
                            />
                        )}
                    />
                }
                label={t("register.SameAddress")}
            />
        );
    }, [control, t]);

    const isCategoryDisabled = (key) => {
        switch (key) {
            case competitionList.Piano:
                return false
            case competitionList.Percussions:
                return false
            case competitionList.Woodwinds:
                return false
            case competitionList.Guitar:
                return false
            case competitionList.VocalChoir:
                return false
            case competitionList.Brass:
                return false
            case competitionList.Harp:
                return false
            case competitionList.Strings:
                return false
            case competitionList.Guzheng:
                return false
            case competitionList.Electone:
                return false
            default:
                return true
        }
    }

    const videoExampleFormatText = useMemo(() => {
        // switch (selectedCompetition) {
        //     case competitionList.Piano:
        //         if (PerformanceCategoryValue === PerformanceCategory.Solo) {
        //             return "*APCSTSOA2025 - PIANO - OPEN AGE - JEREMY GLENN KENNEDY - Scarlatti: Sonata in B Minor, K 27, L 449: Allegro"
        //         } else {
        //             return "*APCSTSOA2025 - PIANO - Any 2-5 instruments with one piano - TIMOTHY’S CHAMBER -FLIGHT OF THE BUMBLEBEE"
        //         }
        //     case competitionList.Woodwinds:
        //         if (PerformanceCategoryValue === PerformanceCategory.Solo) {
        //             return "*APCSTSOA2025 - FLUTE - OPEN AGE - JEREMY GLENN KENNEDY - Scarlatti: Sonata in B Minor, K 27, L 449: Allegro"
        //         } else {
        //             return "*APCSTSOA2025 - Any 2-5 instruments - TIMOTHY’S CHAMBER - FLIGHT OF THE BUMBLEBEE"
        //         }
        //     case competitionList.Percussions:
        //         if (PerformanceCategoryValue === PerformanceCategory.Solo) {
        //             return "*APCSTSOA2025 - MARIMBA - OPEN AGE - JEREMY GLENN KENNEDY - Scarlatti: Sonata in B Minor, K 27, L 449: Allegro"
        //         } else {
        //             return "*APCSTSOA2025 - MULTI PERCUSSION - OPEN AGE - TIMOTHY’S CHAMBER - FLIGHT OF THEBUMBLEBEE"
        //         }
        //     default:
        //         return {}
        // }
        return "*https://youtu.be/FrVWHSeIXnY?si=8moHC_g6ncNZdAZO"
    }, [selectedCompetition, PerformanceCategoryValue])

    useEffect(() => {
        if (userTypeValue !== "Personal") {
            unregister("teacherName");
        }
    }, [userTypeValue, unregister]);

    const tncPdfLink = useMemo(() => {
        switch (selectedCompetition) {
            case competitionList.Piano:
                return "https://drive.google.com/file/d/1h9-XfDL1Rk74EhL1kyLXh_S0zgLZk7Zo/view?usp=drive_link"
            case competitionList.Percussions:
                return "https://drive.google.com/file/d/1W9Hgo6rAn4nRoNBbZib3kqz2dRd-SyDR/view?usp=drive_link"
            case competitionList.Woodwinds:
                return "https://drive.google.com/file/d/1dS8nA-4BV1A6jCX7Kh1uNH4Tv0J91c6M/view?usp=drive_link"
            case competitionList.Guitar:
                return "https://drive.google.com/file/d/1IFJANshn-rzmQus5jW6WAGstKLMVDN-5/view?usp=drive_link"
            case competitionList.VocalChoir:
                return "https://drive.google.com/file/d/1VbsQ_SvGKLShHnomWIQ8d1qDcVE9NHqu/view?usp=drive_link"
            case competitionList.Brass:
                return "https://drive.google.com/file/d/1-u-MBCCEX9tYTVHgQ00_BzO0o8QcXNbl/view?usp=drive_link"
            case competitionList.Harp:
                return "https://drive.google.com/file/d/1mGpv-MdXagKOxCIsAe3ludQ3nNmpTLhC/view?usp=drive_link"
            case competitionList.Strings:
                return "https://drive.google.com/file/d/13slycvfXyLHTEogv-5qX5knrTLX258VT/view?usp=drive_link"
            case competitionList.Guzheng:
                return "https://drive.google.com/file/d/1BhQuQcX3OH5FNGMwjmi5LMXV8tVWcJvu/view?usp=drive_link"
            case competitionList.Electone:
                return "https://drive.google.com/file/d/11hLta7SLW1IXLhSLANV2Frtai6X4BPC8/view?usp=drive_link"
            default:
                return "https://drive.google.com/file/d/1h9-XfDL1Rk74EhL1kyLXh_S0zgLZk7Zo/view?usp=sharing"
        }
    }, [selectedCompetition]);

    const pricePdfLink = useMemo(() => {
        switch (selectedCompetition) {
            case competitionList.Piano:
                return "https://drive.google.com/file/d/1y8zCdACvBfuWafIxOaJPqaBS-LHftSDP/view?usp=drive_link"
            case competitionList.Percussions:
                return "https://drive.google.com/file/d/19bSQmC_VFEcqYaGnurN3b0d0nR9O2roi/view?usp=drive_link"
            case competitionList.Woodwinds:
                return "https://drive.google.com/file/d/1brsGZ77X2p1s1U34qWBS9rjYu1BCnq3R/view?usp=drive_link"
            case competitionList.Guitar:
                return "https://drive.google.com/file/d/1vSNQXTJufxy0xt9ZiGER7X5IUM4RVyfj/view?usp=drive_link"
            case competitionList.VocalChoir:
                return "https://drive.google.com/file/d/1BT9MQp5KXD68qQxbmPESvWAEP8lRuI1g/view"
            case competitionList.Brass:
                return "https://drive.google.com/file/d/1Y50K8H4Z5d3VcrxmYnqmQuoZRzw2pAY4/view?usp=drive_link"
            case competitionList.Harp:
                return "https://drive.google.com/file/d/1GkyWWVxwaikW2yN0UhoPM6ksRYeV_cKF/view?usp=drive_link"
            case competitionList.Strings:
                return "https://drive.google.com/file/d/1T6Aka3iK3EHdYeJrw2S8owN8NKfj-YK_/view?usp=drive_link"
            default:
                return "https://drive.google.com/file/d/1y8zCdACvBfuWafIxOaJPqaBS-LHftSDP/view?usp=drive_link"
        }
    }, [selectedCompetition]);

    const warningPerformenceSchedule = useMemo(() => {
        switch (selectedCompetition) {
            case competitionList.Piano:
                return t("register.warningSchedulePiano");
            case competitionList.Percussions:
                return t("register.warningScheduleOther");
            case competitionList.Woodwinds:
                return t("register.warningScheduleOther");
            case competitionList.Guitar:
                return t("register.warningScheduleOther");
            case competitionList.VocalChoir:
                return t("register.warningScheduleOther");
            case competitionList.Brass:
                return t("register.warningScheduleOther");
            case competitionList.Harp:
                return t("register.warningScheduleOther");
            case competitionList.Strings:
                return t("register.warningScheduleOther");
            default:
                return t("register.warningScheduleOther");
        }
    }, [selectedCompetition]);

    useEffect(() => {
        setValue('instrumentCategory', Object.keys(instrumentCategoryList)[0])
    }, [selectedCompetition])

    const isTraditionalInstrumentSelected = useMemo(() => {
        // First, ensure the value is a string to prevent errors
        if (typeof instrumentCategoryValue !== 'string') {
            return false;
        }

        // Convert the value to lowercase once for efficiency
        const lowercasedValue = instrumentCategoryValue.toLowerCase();

        // Check if the lowercase string includes either the English or Indonesian word
        return lowercasedValue.includes('traditional') || lowercasedValue.includes('tradisional');
    }, [instrumentCategoryValue]);

    useEffect(() => {
        if (!isTraditionalInstrumentSelected) {
            unregister("traditionalInstrument");
        }
    }, [isTraditionalInstrumentSelected, unregister]);

    if (!isRegistrationEnabled) {
        return (
            <div className="primaryBackgroundBlack" style={{ padding: "128px 24px 48px 24px", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div className="container" style={{ maxWidth: "600px" }}>
                    <Box sx={{
                        backgroundColor: "#1E1E1E",
                        borderRadius: "12px",
                        padding: "48px 32px",
                        textAlign: "center",
                        border: "1px solid #EBBC64",
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)"
                    }}>
                        <div className="mb-4 mangolaineFont creamText" style={{ fontSize: isSmallMobileAndSmaller ? "8vmin" : "5vmin", color: "#e5cc92" }}>
                            Registration is Currently Closed
                        </div>
                        <div style={{ color: "#e5cc92", fontSize: "1.1rem", lineHeight: "1.6", marginBottom: "32px" }}>
                            We are performing some scheduled maintenance or updates. Please check back later.
                        </div>
                        <Button 
                            variant="outlined" 
                            onClick={() => navigate('/')}
                            sx={{
                                color: "#EBBC64",
                                borderColor: "#EBBC64",
                                '&:hover': {
                                    borderColor: "#e5cc92",
                                    color: "#e5cc92"
                                }
                            }}
                        >
                            Return to Home
                        </Button>
                    </Box>
                </div>
            </div>
        );
    }


    return (
        <div className="primaryBackgroundBlack" style={{ padding: "128px 0px 48px 0px" }}>
            <div className="container" style={{ marginBottom: 30 }}>
                <div className="row">
                    <div className="col-sm">
                        <div className="mb-4 mangolaineFont creamText d-flex align-items-center justify-center" style={{ fontSize: isSmallMobileAndSmaller ? "8vmin" : "6vmin" }}>
                            {t("register.title")}
                        </div>
                        <img
                            className='mb-4'
                            src={register_poster} // Replace with your actual path
                            alt="Banner"
                            style={{ width: "100%", borderRadius: "3%" }}
                        // style={posterStyle}
                        />

                        <div className="creamText" style={{ color: '#e5cc92' }}>
                            {/* <div>
                                <strong>
                                    {t("register.description.line1")}
                                </strong>
                            </div> */}

                            <strong className='fontSizeFormTitle'>{t("register.description.importantNotes")}</strong>
                            <ul>
                                <li>{t("register.description.ageInfo")}</li>
                                <li>
                                    Country information reflects my current residence and/or passport nationality. Incorrect information may result in disqualification or additional payment.
                                </li>
                                <li>
                                    <strong>APCS Music </strong>{t("register.description.disclaimer")}
                                </li>
                            </ul>
                        </div>
                        <form className="d-flex flex-column" onSubmit={handleOpenConfirmationModal}>
                            {/* <Box className="row">
                                <Box className="col-md-8 col-sm-12">
                                    <FormControl component="fieldset" error={!!errors.userType}>
                                        <FormLabel
                                            className='fontSizeFormTitle'
                                            component="legend"
                                            sx={{
                                                color: "#e5cc92",
                                                "&.Mui-focused": { color: "#e5cc92 !important" },
                                                "&:hover": { color: "#e5cc92 !important" },
                                            }}
                                        >
                                            {t("register.form.whoAreYou")}
                                        </FormLabel>

                                        <Controller
                                            name="userType"
                                            control={control}
                                            rules={{ required: t("register.errors.required") }}
                                            render={({ field }) => (
                                                <RadioGroup {...field} row>
                                                    {Object.entries(userType).map(([key, label]) => (
                                                        <FormControlLabel
                                                            id={`${key}-${label}`}
                                                            key={key}
                                                            value={key}
                                                            control={
                                                                <Radio
                                                                    sx={{
                                                                        color: "#e5cc92",
                                                                        "&.Mui-checked": { color: "#e5cc92" },
                                                                        "&.Mui-focusVisible": {
                                                                            outline: "2px solid #e5cc92",
                                                                        },
                                                                        "&.Mui-checked.Mui-focusVisible": {
                                                                            outline: "2px solid #e5cc92",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label={label}
                                                            sx={{ color: "#e5cc92" }}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            )}
                                        />
                                        {errors.userType && (
                                            <p style={{ color: "red" }}>{errors.userType.message}</p>
                                        )}
                                    </FormControl>
                                </Box>
                            </Box> */}


                            {/* Teacher's/Parent's Name */}
                            {/* <Controller
                                name="name"
                                control={control}
                                // Add the new rules for minLength and pattern here
                                rules={{
                                    required: t("register.errors.required"),
                                    minLength: {
                                        value: 3,
                                        message: t("register.errors.nameMinLength") // New error message
                                    },
                                    pattern: {
                                        value: /^[A-Za-z\s'-]+$/, // Regex to allow letters, spaces, apostrophes, hyphens
                                        message: t("register.errors.nameMinLength") // New error message
                                    }
                                }}
                                render={({ field, fieldState: { error } }) => (
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <TextField
                                            {...field}
                                            label={userTypeValue !== "Teacher"
                                                ? t("register.form.parentName")
                                                : t("register.form.teacherName")}
                                            variant="standard"
                                            className="custom-textfield-full mb-4"
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                            placeholder={t('register.form.placeholder_register_self')}
                                        />

                                        <Tooltip
                                            enterTouchDelay={0}
                                            title={t("register.form.teacherNameNote")}>
                                            <IconButton sx={{ color: "#e5cc92", fontSize: 16, mt: 1 }}>
                                                <QuestionCircleOutlined />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                )}
                            /> */}
                            {/* {userTypeValue === "Personal" && (
                                <Controller
                                    name="teacherName"
                                    control={control}
                                    // Add the new rules inside the existing ternary operator
                                    rules={userTypeValue === "Personal" ? {
                                        required: t("register.errors.required"),
                                        minLength: {
                                            value: 3,
                                            message: t("register.errors.nameMinLength")
                                        },
                                        pattern: {
                                            value: /^[A-Za-z\s'-]+$/,
                                            message: t("register.errors.nameMinLength")
                                        }
                                    } : {}}
                                    render={({ field, fieldState: { error } }) => (
                                        userTypeValue === "Personal" && (
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <TextField
                                                    {...field}
                                                    label={t("register.form.teacherName")}
                                                    variant="standard"
                                                    className="custom-textfield-full mb-4"
                                                    error={!!error}
                                                    helperText={error ? error.message : ""}
                                                />
                                            </div>
                                        )
                                    )}
                                />
                            )} */}

                            {/* Competition Category (Radio Button) */}
                            <FormControl className='mt-2' component="fieldset" error={!!errors.competitionCategory}>
                                <FormLabel
                                    className='fontSizeFormTitle'
                                    component="legend"
                                    sx={{
                                        color: "#e5cc92",
                                        "&.Mui-focused": { color: "#e5cc92 !important" },
                                        "&:hover": { color: "#e5cc92 !important" },
                                    }}
                                >
                                    {t("register.form.competitionCategory")}
                                </FormLabel>

                                <Controller
                                    name="competitionCategory"
                                    control={control}
                                    rules={{ required: t("register.errors.required") }}
                                    render={({ field }) => (
                                        <RadioGroup {...field} row>
                                            {Object.entries(competitionList).map(([key, label]) => (
                                                <FormControlLabel
                                                    id={`${key}-${label}`}
                                                    key={key}
                                                    value={key}
                                                    disabled={isCategoryDisabled(key)}
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "#e5cc92",
                                                                "&.Mui-checked": {
                                                                    color: "#e5cc92",
                                                                },
                                                                "&.Mui-focusVisible": {
                                                                    outline: "2px solid #e5cc92",
                                                                },
                                                                "&.Mui-checked.Mui-focusVisible": {
                                                                    outline: "2px solid #e5cc92",
                                                                },
                                                                "&.Mui-disabled": {
                                                                    color: "#a18f65", // Custom color when disabled
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={t(`register.competitionList.${key}`)}
                                                    sx={{
                                                        color: "#e5cc92",
                                                        "&.Mui-disabled": {
                                                            color: "#a18f65", // Disabled label color
                                                            ".MuiTypography-root": {
                                                                color: "#a18f65", // Text node inside the label
                                                            },
                                                        },
                                                    }}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                                {errors.competitionCategory && (
                                    <p style={{ color: "red" }}>{errors.competitionCategory.message}</p>
                                )}
                            </FormControl>

                            {selectedCompetition === competitionList.VocalChoir && (
                                <FormControl className='mt-2' component="fieldset" error={!!errors.vocalGenreCategory}>
                                    <FormLabel
                                        className='fontSizeFormTitle'
                                        component="legend"
                                        sx={{
                                            color: "#e5cc92",
                                            "&.Mui-focused": { color: "#e5cc92 !important" },
                                            "&:hover": { color: "#e5cc92 !important" },
                                        }}
                                    >
                                        {t("register.form.vocalGenreCategory")}
                                    </FormLabel>

                                    <Controller
                                        name="vocalGenreCategory"
                                        control={control}
                                        rules={{ required: t("register.errors.required") }}
                                        render={({ field }) => (
                                            <RadioGroup {...field} row>
                                                {Object.entries(VocalGenreCategory).map(([key, label]) => (
                                                    <FormControlLabel
                                                        id={`${key}-${label}`}
                                                        key={key}
                                                        value={key}
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    color: "#e5cc92",
                                                                    "&.Mui-checked": {
                                                                        color: "#e5cc92",
                                                                    },
                                                                    "&.Mui-focusVisible": {
                                                                        outline: "2px solid #e5cc92",
                                                                    },
                                                                    "&.Mui-checked.Mui-focusVisible": {
                                                                        outline: "2px solid #e5cc92",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label={t(`register.form.${key}`)}
                                                        sx={{ color: "#e5cc92" }}
                                                    />
                                                ))}
                                            </RadioGroup>
                                        )}
                                    />
                                    {errors.vocalGenreCategory && (
                                        <p style={{ color: "red" }}>{errors.vocalGenreCategory.message}</p>
                                    )}
                                </FormControl>
                            )}

                            <div className="text-white whitespace-nowrap" style={{ fontSize: 14 }}>
                                Terms and Conditions can be found{" "}
                                <a href={tncPdfLink}
                                    target='_blank'
                                    style={{ color: '#FBBF24' }}
                                    className="font-medium underline decoration-amber-400/50 underline-offset-4 transition-colors hover:text-amber-300 hover:decoration-amber-300"
                                >
                                    here
                                </a>
                                {/* , and pricing details are available{" "}
                                <a href={pricePdfLink}
                                    target='_blank'
                                    style={{ color: '#FBBF24' }}
                                    className="font-medium underline decoration-amber-400/50 underline-offset-4 transition-colors hover:text-amber-300 hover:decoration-amber-300"
                                >
                                    here
                                </a> */}
                                .
                            </div>

                            {warningPerformenceSchedule !== null && (
                                <p style={{ color: '#FBBF24', marginTop: '12px', fontSize: '14px', maxWidth: '100%' }}>
                                    <strong>{t("register.importantNotice")}</strong> {warningPerformenceSchedule}
                                </p>
                            )}

                            {/* Performance Category */}
                            <RadioForm
                                errors={errors}
                                control={control}
                                title={t("register.PerformanceCategoryTitle")}
                                name='PerformanceCategory'
                                itemList={PerformanceCategory}
                                setValue={setValue}
                            />
                            {selectedCompetition === competitionList.Guitar && PerformanceCategoryValue === PerformanceCategory.Solo && (
                                <small className="note">*{t("register.noElectric")}. </small>
                            )}


                            {/* Instrument Category (Radio Buttons) */}
                            <FormControl className='mt-4' component="fieldset" error={!!errors.instrumentCategory}>
                                <FormLabel
                                    className='fontSizeFormTitle'
                                    component="legend"
                                    sx={{
                                        color: "#e5cc92",
                                        "&.Mui-focused": { color: "#e5cc92 !important" },
                                        "&:hover": { color: "#e5cc92 !important" },
                                    }}
                                >
                                    {t("register.form.instrumentCategory")}
                                </FormLabel>

                                <Controller
                                    name="instrumentCategory"
                                    control={control}
                                    rules={{ required: t("register.errors.required") }}
                                    render={({ field }) => (
                                        <RadioGroup {...field}
                                            value={field.value || ""}
                                            row>
                                            {Object.entries(instrumentCategoryList).map(([key, label]) => (
                                                <FormControlLabel
                                                    id={`${key}-${label}`}
                                                    key={key}
                                                    value={key}
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "#e5cc92",
                                                                "&.Mui-checked": {
                                                                    color: "#e5cc92",
                                                                },
                                                                "&.Mui-focusVisible": {
                                                                    outline: "2px solid #e5cc92",
                                                                },
                                                                "&.Mui-checked.Mui-focusVisible": {
                                                                    outline: "2px solid #e5cc92",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={t(`register.instrumentList.${key}`)}
                                                    sx={{ color: "#e5cc92" }}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                                {errors.instrumentCategory && (
                                    <p style={{ color: "red" }}>{errors.instrumentCategory.message}</p>
                                )}
                            </FormControl>
                            {selectedCompetition === competitionList.Harp && PerformanceCategoryValue === PerformanceCategory.Ensemble && (
                                <small className="note">*Solo Pedal with Ensemble/Piano, Lever Harp with Ensemble/
                                    Piano, Harp Ensemble. </small>
                            )}

                            {isTraditionalInstrumentSelected && (
                                <Controller
                                    name="traditionalInstrument"
                                    control={control}
                                    rules={isTraditionalInstrumentSelected ? {
                                        required: t("register.errors.required"),
                                        minLength: {
                                            value: 3,
                                            message: t("register.errors.nameMinLength")
                                        }
                                    } : {}}
                                    render={({ field, fieldState: { error } }) => (
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <TextField
                                                {...field}
                                                label={t("register.form.traditionalInstrument")}
                                                variant="standard"
                                                className="custom-textfield-full mb-4"
                                                error={!!error}
                                                helperText={error ? error.message : ""}
                                            />
                                        </div>
                                    )}
                                />
                            )}

                            {/* Total Performer */}
                            <Box className="row mt-2">
                                <Box className="col-6 col-md-2">
                                    <FormControl component="fieldset" error={!!errors.totalPerformer}>
                                        <FormLabel
                                            className='fontSizeFormTitle'
                                            component="legend"
                                            sx={{
                                                color: "#e5cc92",
                                                "&.Mui-focused": { color: "#e5cc92 !important" },
                                                "&:hover": { color: "#e5cc92 !important" },
                                            }}
                                        >
                                            {t("register.form.performerCount")}
                                        </FormLabel>

                                        <Controller
                                            name="totalPerformer"
                                            control={control}
                                            rules={{ required: t("register.errors.required") }}
                                            render={({ field, fieldState: { error } }) => (
                                                <CustomNumberInput
                                                    value={field.value || minimalPerformer}
                                                    onChange={(value) => {
                                                        if (PerformanceCategoryValue !== PerformanceCategory.Solo) {
                                                            field.onChange(value);
                                                            handleChangePerformer(value);
                                                        }
                                                    }}
                                                    min={minimalPerformer}
                                                    max={maximalPerformer}
                                                    suffix={t("register.form.personSuffix")}
                                                    disabled={PerformanceCategoryValue === PerformanceCategory.Solo}
                                                    error={!!error}
                                                />
                                            )}
                                        />

                                        <small className="note">*{performerExpText}. </small>

                                        {errors.totalPerformer && (
                                            <p style={{ color: "red" }}>{errors.totalPerformer.message}</p>
                                        )}
                                    </FormControl>
                                </Box>
                            </Box>

                            {/* #region Student's Personal Information*/}
                            {fields.map((item, index) => (
                                <React.Fragment key={item.id ? item.id : `performer-${index}`}>
                                    <FormLabel
                                        className='mt-4 fontSizeFormTitle'
                                        component="legend"
                                        sx={{
                                            color: "#e5cc92",
                                            "&.Mui-focused": { color: "#e5cc92 !important" },
                                            "&:hover": { color: "#e5cc92 !important" },
                                            marginBottom: 0,
                                        }}
                                    >
                                        {`${t("register.form.personalInformation")} ${index + 1}`}
                                    </FormLabel>

                                    {/* First & Last Name */}
                                    <Controller
                                        name={`performers.${index}.fullName`}
                                        control={control}
                                        rules={{ required: t("register.errors.required") }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                placeholder="John Doe"
                                                key={`${`fullName-${index}`}`}
                                                label={t("register.form.fullName")}
                                                variant="standard"
                                                className="custom-textfield-full mb-4"
                                                error={!!error}
                                                helperText={error?.message} />
                                        )}
                                    />

                                    {/* Nationality, DOB, Gender */}
                                    <Box className="row mt-2">
                                        <Box className="col-6">
                                            <Controller
                                                name={`performers.${index}.nationality`}
                                                control={control}
                                                rules={{ required: t("register.errors.required") }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField
                                                        {...field}
                                                        placeholder="Indonesia"
                                                        label={t("register.form.nationality")}
                                                        variant="standard"
                                                        className="custom-textfield-full mb-4"
                                                        error={!!error}
                                                        helperText={error?.message}
                                                    />
                                                )}
                                            />
                                        </Box>

                                        <Box className="col-6 col-md-3 align-content-center">
                                            <Box className='d-flex' sx={{ width: "100%", gap: 4 }}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Controller
                                                        name={`performers.${index}.dob`}
                                                        control={control}
                                                        rules={{ required: t("register.errors.required") }}
                                                        render={({ field, fieldState: { error } }) => (
                                                            <DatePicker
                                                                {...field}
                                                                label={t("register.form.dob")}
                                                                value={field.value ? dayjs(field.value) : null}
                                                                onChange={(newValue) => field.onChange(newValue)}
                                                                format='DD/MM/YYYY'
                                                                sx={{
                                                                    // mt: 2,
                                                                    // mb: 2,
                                                                    "& .MuiInputBase-root": {
                                                                        color: "#e5cc92", // Gold text color
                                                                    },
                                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#e5cc92 !important", // Gold border (default)
                                                                    },
                                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#e5cc92 !important", // Gold border on hover
                                                                    },
                                                                    "& .MuiInputLabel-root": {
                                                                        color: "#e5cc92", // Gold label color
                                                                    },
                                                                    "& .MuiInputLabel-root.Mui-focused": {
                                                                        color: "#e5cc92 !important", // Force gold label on focus
                                                                    },
                                                                    "& .MuiIconButton-root": {
                                                                        color: "#e5cc92", // Gold calendar icon
                                                                    },
                                                                    "& .MuiPickersDay-root": {
                                                                        color: "#e5cc92", // Gold date numbers
                                                                    },
                                                                    "& .MuiPickersDay-root.Mui-selected": {
                                                                        backgroundColor: "#e5cc92", // Gold background on selected date
                                                                        color: "black", // Black text on selected date
                                                                    },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                            borderColor: "#e5cc92 !important", // Force gold outline when focused
                                                                        },
                                                                    },
                                                                    "& .MuiInputBase-input": {
                                                                        caretColor: "#e5cc92", // Gold cursor
                                                                    },
                                                                    "& .Mui-focused": {
                                                                        color: "#e5cc92 !important", // Forces gold text when focused
                                                                    },
                                                                    "& .MuiOutlinedInput-root.Mui-focused": {
                                                                        borderColor: "#e5cc92 !important", // Forces gold border when focused
                                                                    },
                                                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#e5cc92 !important", // Forces gold border line when focused
                                                                    },
                                                                }}
                                                                slotProps={{
                                                                    textField: {
                                                                        variant: "outlined",
                                                                        error: !!error,
                                                                        helperText: error ? error.message : "",
                                                                        InputLabelProps: { shrink: true },
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </Box>


                                        </Box>

                                        <Box className="col-12 col-md-3 align-content-center">
                                            <FormControl component="fieldset" error={!!errors.userType}>
                                                <FormLabel
                                                    component="legend"
                                                    sx={{
                                                        color: "#e5cc92",
                                                        "&.Mui-focused": { color: "#e5cc92 !important" },
                                                        "&:hover": { color: "#e5cc92 !important" },
                                                    }}
                                                >
                                                    {t("register.form.gender")}
                                                </FormLabel>

                                                <Controller
                                                    name={`performers.${index}.gender`}
                                                    control={control}
                                                    rules={{ required: t("register.errors.required") }}
                                                    render={({ field }) => (
                                                        <RadioGroup {...field} row>
                                                            {Object.entries(gender).map(([key, label]) => (
                                                                <FormControlLabel
                                                                    id={`${key}-${label}`}
                                                                    key={key}
                                                                    value={key}
                                                                    control={
                                                                        <Radio
                                                                            sx={{
                                                                                color: "#e5cc92", // Unselected color
                                                                                "&.Mui-checked": {
                                                                                    color: "#e5cc92", // Selected color
                                                                                },

                                                                                // 👇 Removes blue focus and replaces with gold glow
                                                                                "&.Mui-focusVisible": {
                                                                                    outline: "2px solid #e5cc92", // Gold outline when focused
                                                                                },
                                                                                "&.Mui-checked.Mui-focusVisible": {
                                                                                    outline: "2px solid #e5cc92", // Gold glow for checked state
                                                                                },
                                                                            }}
                                                                        />
                                                                    }
                                                                    label={label}
                                                                    sx={{ color: "#e5cc92" }}
                                                                />
                                                            ))}
                                                        </RadioGroup>
                                                    )}
                                                />
                                                {errors.performers?.[index]?.gender && (
                                                    <p style={{ color: "red", marginTop: "4px" }}>
                                                        {errors.performers[index].gender.message}
                                                    </p>
                                                )}
                                            </FormControl>
                                        </Box>
                                    </Box>

                                    {/* Email & Phone */}
                                    <Box className="row align-items-center">
                                        <Box className="col-12 col-md-6">
                                            <Controller
                                                name={`performers.${index}.email`}
                                                control={control}
                                                rules={{
                                                    required: t("register.errors.required"),
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                                        message: t("register.errors.email")
                                                    }
                                                }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField
                                                        {...field}
                                                        type="email" // Ensure email input type is set
                                                        placeholder="JohnDoe@gmail.com"
                                                        id="standard-basic"
                                                        label={t("register.form.email")}
                                                        variant="standard"
                                                        className="custom-textfield-full mb-4"
                                                        error={!!error}
                                                        helperText={error ? error.message : ""}
                                                    />
                                                )}
                                            />
                                        </Box>
                                        <Box className="col-12 col-md-6">
                                            <Controller
                                                name={`performers.${index}.phoneNumber`}
                                                control={control}
                                                rules={{ required: t("register.errors.required") }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <InputNumber
                                                        {...field}
                                                        style={{
                                                            width: '100%',
                                                            color: '#e5cc92',
                                                            borderColor: '#e5cc92',
                                                            backgroundColor: 'white',
                                                        }}
                                                        className="custom-input-gold"
                                                        addonBefore={
                                                            <Controller
                                                                name={`performers.${index}.countryCode`}
                                                                control={control}
                                                                defaultValue={['+62']}
                                                                rules={{ required: t("register.errors.required") }}
                                                                render={({ field }) => (
                                                                    <Cascader
                                                                        {...field}
                                                                        value={field.value} // Explicitly bind the value
                                                                        onChange={field.onChange} // Make sure changes are captured
                                                                        options={countryCodes.map(code => ({ value: code.code, label: code.name }))}
                                                                        placeholder="+Code"
                                                                        style={{
                                                                            width: 150,
                                                                            color: '#e5cc92',
                                                                            fontSize: 12,
                                                                            borderColor: '#e5cc92',
                                                                            backgroundColor: 'white',
                                                                        }}
                                                                        dropdownStyle={{
                                                                            // color: '#e5cc92',
                                                                        }}
                                                                        popupClassName="custom-cascader-popup"
                                                                    />
                                                                )}
                                                            />
                                                        }
                                                        status={error ? 'error' : ''}
                                                    />
                                                )}
                                            />
                                            {errors.performers?.[index]?.phoneNumber && (
                                                <p style={{ color: "red", marginTop: "4px" }}>
                                                    {errors.performers[index].phoneNumber.message}
                                                </p>
                                            )}
                                        </Box>
                                    </Box>

                                    {/* City / Country */}
                                    <Box className="row">
                                        <Box className="col-6">
                                            <Controller
                                                name={`performers.${index}.city`}
                                                control={control}
                                                rules={{ required: t("register.errors.required") }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField {...field}
                                                        // key={`${sameAddressValue ? field.value : `city-${index}`}`} // 👈 force rerender when value changes
                                                        // value={field.value ?? ''}
                                                        key={`${`city-${index}`}`}
                                                        InputLabelProps={{ shrink: Boolean(field.value) }} // 👈 Optional: forces label to float when value exists
                                                        label={t("register.form.city")}
                                                        variant="standard"
                                                        className="custom-textfield-full mb-4"
                                                        error={!!error}
                                                        helperText={error?.message} />
                                                )}
                                            />
                                        </Box>
                                        <Box className="col-6">
                                            <Controller
                                                name={`performers.${index}.country`}
                                                control={control}
                                                rules={{ required: t("register.errors.required") }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField {...field}
                                                        // key={`${sameAddressValue ? field.value : `country-${index}`}`} // 👈 force rerender when value changes
                                                        // value={field.value ?? ''}
                                                        key={`${`country-${index}`}`}
                                                        InputLabelProps={{ shrink: Boolean(field.value) }} // 👈 Optional: forces label to float when value exists
                                                        label={t("register.form.country")} variant="standard" className="custom-textfield-full mb-4" error={!!error} helperText={error?.message} />
                                                )}
                                            />
                                        </Box>
                                    </Box>

                                    {/* Province / Zipcode */}
                                    <Box className="row">
                                        <Box className="col-6">
                                            <Controller
                                                name={`performers.${index}.province`}
                                                control={control}
                                                rules={{ required: t("register.errors.required") }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField {...field}
                                                        // key={`${sameAddressValue ? field.value : `province-${index}`}`} // 👈 force rerender when value changes
                                                        // value={field.value ?? ''}
                                                        key={`${`province-${index}`}`}
                                                        InputLabelProps={{ shrink: Boolean(field.value) }} // 👈 Optional: forces label to float when value exists
                                                        label={t("register.form.province")} variant="standard" className="custom-textfield-full mb-4" error={!!error} helperText={error?.message} />
                                                )}
                                            />
                                        </Box>
                                        <Box className="col-6">
                                            <Controller
                                                name={`performers.${index}.zipCode`}
                                                control={control}
                                                rules={{ required: t("register.errors.required") }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField {...field}
                                                        // key={`${sameAddressValue ? field.value : `zipCode-${index}`}`} // 👈 force rerender when value changes
                                                        // value={field.value ?? ''}
                                                        key={`${`zipCode-${index}`}`}
                                                        InputLabelProps={{ shrink: Boolean(field.value) }} // 👈 Optional: forces label to float when value exists
                                                        label={t("register.form.zipcode")} variant="standard" className="custom-textfield-full mb-4" error={!!error} helperText={error?.message} />
                                                )}
                                            />
                                        </Box>
                                    </Box>

                                    {/* Address */}
                                    <Controller
                                        name={`performers.${index}.addressLine`}
                                        control={control}
                                        rules={{ required: t("register.errors.required") }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField {...field}
                                                // key={`${sameAddressValue ? field.value : `addressLine-${index}`}`} // 👈 force rerender when value changes
                                                // value={field.value ?? ''}
                                                key={`${`addressLine-${index}`}`}
                                                InputLabelProps={{ shrink: Boolean(field.value) }} // 👈 Optional: forces label to float when value exists
                                                label={t("register.form.address")} variant="standard" className="custom-textfield-full mb-4" error={!!error} helperText={error?.message} />
                                        )}
                                    />

                                    {index === 0 && (
                                        sameAddressCheckbox
                                    )}
                                </React.Fragment>
                            )
                            )}

                            {/* Age Category (Radio Buttons) */}
                            <FormControl className='mt-4' component="fieldset" error={!!errors.ageCategory}>
                                <FormLabel
                                    className='fontSizeFormTitle'
                                    component="legend"
                                    sx={{
                                        color: "#e5cc92",
                                        "&.Mui-focused": { color: "#e5cc92 !important" },
                                        "&:hover": { color: "#e5cc92 !important" },
                                    }}
                                >
                                    {t("register.form.ageCategory")}
                                </FormLabel>

                                {Object.keys(filteredAgeCategoriesByAge).length === 0 && (
                                    <Alert
                                        severity="warning"
                                        sx={{
                                            mt: 2,
                                            mb: 1,
                                            backgroundColor: "rgba(255, 152, 0, 0.1)",
                                            color: "#e5cc92",
                                            border: "1px solid #e5cc92",
                                            "& .MuiAlert-icon": {
                                                color: "#e5cc92"
                                            }
                                        }}
                                    >
                                        {t("register.errors.noAgeCategoryMatched")}
                                    </Alert>
                                )}

                                <Controller
                                    name="ageCategory"
                                    control={control}
                                    rules={{ required: t("register.errors.required") }}
                                    render={({ field }) => (
                                        <RadioGroup {...field} row>
                                            {Object.entries(filteredAgeCategoriesByAge).map(([key, label]) => (
                                                <FormControlLabel
                                                    id={`${key}-${label}`}
                                                    key={key}
                                                    value={key}
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "#e5cc92",
                                                                "&.Mui-checked": {
                                                                    color: "#e5cc92",
                                                                },
                                                                "&.Mui-focusVisible": {
                                                                    outline: "2px solid #e5cc92",
                                                                },
                                                                "&.Mui-checked.Mui-focusVisible": {
                                                                    outline: "2px solid #e5cc92",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={t(`register.ageCategories.${key}`)}
                                                    sx={{ color: "#e5cc92" }}
                                                />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                                {errors.ageCategory && (
                                    <p style={{ color: "red" }}>{errors.ageCategory.message}</p>
                                )}
                            </FormControl>

                            <Controller
                                name="teacherName"
                                control={control}
                                // Add the new rules inside the existing ternary operator
                                rules={{
                                    required: t("register.errors.required"),
                                    minLength: {
                                        value: 3,
                                        message: t("register.errors.nameMinLength")
                                    },
                                    pattern: {
                                        value: /^[A-Za-z\s'-]+$/,
                                        message: t("register.errors.nameMinLength")
                                    }
                                }}
                                render={({ field, fieldState: { error } }) => (
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <TextField
                                            {...field}
                                            label={t("register.form.teacherName")}
                                            variant="standard"
                                            className="custom-textfield-full mb-4"
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                        />
                                    </div>
                                )}
                            />

                            {/* Payment Proof */}
                            {/* {!isInternationalRegistrant && (
                                <>
                                    < FileInput
                                        name="paymentProof"
                                        control={control}
                                        label={t("register.form.paymentProof")}
                                        smallNotes={<small className="note">{t("register.notes.paymentProof")}</small>}
                                        extraSmallNotes={<small className="note">{t("register.notes.paymentProof2")}</small>}
                                        rules={{ required: t("register.errors.required") }}
                                        tooltipLabel={t("register.form.paymentProofTooltip")}
                                        inputRef={paymentProofInputRef}
                                        setValue={setValue}
                                    />

                                    <Box className="row">
                                        <Box sx={{
                                            width: { xs: '83.33%', md: '33.33%' }, // 10/12 on mobile, 4/12 on desktop
                                            paddingRight: 0
                                        }}>
                                            <Controller
                                                name="remark"
                                                control={control}
                                                rules={{ required: t("register.errors.required") }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField
                                                        {...field}
                                                        sx={{ mt: 2 }}
                                                        label={t("register.form.remark")}
                                                        variant="standard"
                                                        className="custom-textfield-full mb-4"
                                                        error={!!error}
                                                        helperText={error ? error.message : ""}
                                                    />
                                                )}
                                            />
                                        </Box>
                                        <Box sx={{
                                            width: { xs: '16.67%', md: '66.67%' }, // 2/12 on mobile, 8/12 on desktop
                                            alignContent: "center",
                                            paddingLeft: 0
                                        }}>
                                            <Tooltip title={
                                                <div>
                                                    <p>{t("register.form.remarksNote")}</p>
                                                </div>
                                            }>
                                                <IconButton sx={{ color: "#e5cc92", fontSize: 16, mt: 1 }}>
                                                    <QuestionCircleOutlined />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </>
                            )} */}

                            {/* Profile Picture Upload */}
                            {/* <FileInput
                                name="profilePhoto"
                                control={control}
                                label={t("register.form.profilePhoto")}
                                smallNotes={<small className="note">{t("register.notes.uploadCombined")}</small>}
                                extraSmallNotes={<small className="note">{t("register.notes.profilePhoto")}</small>}
                                extraExtraSmallNotes={<small className="note">{t("register.notes.profilePhoto2")}</small>}
                                rules={{ required: t("register.errors.required") }}
                                tooltipLabel={t("register.form.profilePhotoTooltip")}
                                inputRef={profilePhotoInputRef}
                                setValue={setValue}
                            /> */}

                            {/* Exam Certificate Upload */}
                            {/* <FileInput
                                name="examCertificate"
                                control={control}
                                label={t("register.form.examCert")}
                                smallNotes={<small className="note">{t("register.notes.uploadCombined")}</small>}
                                extraSmallNotes={<small className="note">{t("register.notes.fileFormatExam")}</small>}
                                rules={{ required: t("register.errors.required") }}
                                tooltipLabel={t("register.form.examCertTooltip")}
                                inputRef={examInputRef}
                                setValue={setValue}
                            /> */}

                            {/* Pasport Upload */}
                            <FileInput
                                name="birthCertificate"
                                control={control}
                                label={t("register.form.birthCert")}
                                smallNotes={<small className="note">{t("register.notes.uploadCombined")}</small>}
                                extraSmallNotes={<small className="note">{t("register.notes.fileFormatBirthCert")}</small>}
                                rules={{ required: t("register.errors.required") }}
                                tooltipLabel={t("register.form.birthCertTooltip")}
                                inputRef={birthCertInputRef}
                                setValue={setValue}
                            />

                            {/* PDF Repertoire Upload */}
                            <FileInput
                                name="pdfRepertoire"
                                control={control}
                                label={t("register.form.repertoire")}
                                smallNotes={<small className="note">{t("register.notes.uploadCombined")}</small>}
                                extraSmallNotes={<small className="note">{t("register.notes.fileFormatRepertoire")}</small>}
                                rules={{ required: t("register.errors.required") }}
                                tooltipLabel={t("register.form.repertoireTooltip")}
                                inputRef={repertoireInputRef}
                                setValue={setValue}
                            />

                            <FileInput
                                name="videoPerformance"
                                control={control}
                                label={t("register.form.videoPerformance")}
                                smallNotes={<small className="note">{t("register.notes.uploadVideoPerformance")}</small>}
                                extraSmallNotes={<small className="note">{t("register.notes.fileFormatVideoPerformance")}</small>}
                                rules={{ required: t("register.errors.required") }}
                                tooltipLabel={t("register.form.videoPerformanceTooltip")}
                                inputRef={videoPerformanceInputRef}
                                setValue={setValue}
                                acceptedFormats="video/*"
                            />

                            {/* <small className="note">
                                {videoExampleFormatText}
                            </small> */}

                            {/* Agreement */}
                            <Box className="creamText" sx={{ mt: 2, textAlign: "justify" }}>
                                {t("register.form.agreementText")}
                            </Box>
                            <FormControlLabel
                                sx={{
                                    color: "#e5cc92",
                                    "&.Mui-focused": { color: "#e5cc92 !important" },
                                    "&:hover": { color: "#e5cc92 !important" },
                                }}
                                control={
                                    <Controller
                                        name="agreement"
                                        control={control}
                                        rules={{ required: t("register.errors.required") }}
                                        render={({ field }) => (
                                            <Checkbox
                                                {...field}
                                                sx={{
                                                    color: "#e5cc92",
                                                    "&.Mui-checked": {
                                                        color: "#e5cc92",
                                                    },
                                                    "&.Mui-focusVisible": {
                                                        outline: "2px solid #e5cc92",
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                }
                                label={t("register.form.agree")}
                            />
                            {errors.agreement && <p style={{ color: "red" }}>{errors.agreement.message}</p>}


                            {/* TODO move this to env */}
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey="6LczRE4sAAAAAM2c5xyARIsoZuxcWcm3jWx1voP-"
                                theme="dark"
                            />

                            {/* Submit Button */}
                            {isSaveSuccess ? (
                                <Button
                                    disabled={isLoading}
                                    onClick={handleClickReset}
                                    variant="contained" color="primary"
                                    sx={{
                                        backgroundColor: "#e5cc92",
                                        color: "black",
                                        // Override disabled styles to keep the same background and text color
                                        "&.Mui-disabled": {
                                            backgroundColor: "#e5cc92",
                                            color: "black",
                                            opacity: 0.5, // you can adjust the opacity to indicate disabled state
                                        },
                                        "&:hover": { backgroundColor: "#d9a84d" },

                                    }}
                                >
                                    {t("register.submitAnotherRegistrant")}
                                </Button>
                            ) : (
                                <Button
                                    disabled={isLoading}
                                    type="submit" variant="contained" color="primary"
                                    sx={{
                                        backgroundColor: "#e5cc92",
                                        padding: "8px",
                                        color: "black",
                                        // Override disabled styles to keep the same background and text color
                                        "&.Mui-disabled": {
                                            backgroundColor: "#e5cc92",
                                            color: "black",
                                            position: 'relative',
                                            opacity: 0.5, // you can adjust the opacity to indicate disabled state
                                        },
                                        "&:hover": { backgroundColor: "#d9a84d" },

                                    }}
                                >
                                    {t("register.submit")}
                                </Button>
                            )}
                            {paymentLink && (
                                <div style={{ marginTop: 30, textAlign: 'center' }}>
                                    <p style={{ color: '#e5cc92', marginBottom: 10, fontSize: '14px' }}>
                                        {t("register.paymentPageNotOpen")}
                                    </p>
                                    <Button
                                        type="default"
                                        shape="round"
                                        icon={<CreditCardOutlined />}
                                        size="large"
                                        onClick={handleClickOpenPaymentLink}
                                        style={{
                                            backgroundColor: 'transparent',
                                            color: '#e5cc92',
                                            borderColor: '#e5cc92',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {t("register.payViaPaper")}
                                    </Button>
                                </div>
                            )}
                            <LoadingOverlay open={isLoading} progress={progressLoading} />

                            <SubmissionConfirmationModal
                                open={isConfirmModalOpen}
                                onCancel={() => setIsConfirmModalOpen(false)}
                                onConfirm={handleSubmit(onSubmit, onError)}
                            />
                        </form>
                    </div>
                </div>
            </div >
            {/* <WelcomeModalRegister
                open={isWarningModalOpen}
                handleClose={handleCloseWarning}
            /> */}
        </div >

    )
}

export default Register;